import { pipe } from "fp";
import React from "react";

import * as Data from "~/Data";
import * as ELD from "~/ELD";
import * as Table from "~/Table";

import * as Body from "./Body";
import * as Head from "./Head";

export const colSpan = Head.colSpan;

export const Component = () =>
  pipe(
    ELD.useStore(),
    Data.Store.when({
      success: () => <Body.Component />,
      loading: () => <Table.Wide.Loading.Component colSpan={Head.colSpan()} />,
      error: (error) => (
        <Table.Wide.ErrorMessage.Component colSpan={Head.colSpan()}>
          {error.message}
        </Table.Wide.ErrorMessage.Component>
      ),
    }),
    (children) => (
      <Table.Component>
        <Head.Component />
        {children}
      </Table.Component>
    )
  );
